// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fin .espaceHaut {
    height: 8vh;
}

@media (max-width: 992px) {
    .fin .espaceHaut {
        height: 5vh;
    }
}


/* Vidéo Vimeo de Fin2 : mêmes tailles qu'en prod, où elles venaient d'une règle iframe globale
   de l'ancien Univers.css (retirée avec la refonte de la carte) */
.fin iframe {
    width: 100%;
    height: 600px;
}

@media (max-width: 992px) {
    .fin iframe {
        height: 425px;
    }
}

@media (max-width: 768px) {
    .fin iframe {
        height: 290px;
    }
}

@media (max-width: 575px) {
    .fin iframe {
        height: 310px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/Fin.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;;AAGA;kEACkE;AAClE;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".fin .espaceHaut {\n    height: 8vh;\n}\n\n@media (max-width: 992px) {\n    .fin .espaceHaut {\n        height: 5vh;\n    }\n}\n\n\n/* Vidéo Vimeo de Fin2 : mêmes tailles qu'en prod, où elles venaient d'une règle iframe globale\n   de l'ancien Univers.css (retirée avec la refonte de la carte) */\n.fin iframe {\n    width: 100%;\n    height: 600px;\n}\n\n@media (max-width: 992px) {\n    .fin iframe {\n        height: 425px;\n    }\n}\n\n@media (max-width: 768px) {\n    .fin iframe {\n        height: 290px;\n    }\n}\n\n@media (max-width: 575px) {\n    .fin iframe {\n        height: 310px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
